import axios, { AxiosResponse } from "axios";
import {
    DashboardStats,
    StatsBerthingsPerDock,
    StatsBookingPerStatus,
    StatsExpensePerDock,
    StatsExpensePerShip,
    StatsExpensePerShipAndDock,
} from "../models/stats";
import {
    CsvStatisticsFilters,
    StatisticsFilters,
} from "../containers/StatisticsPage/shared/filters";
import { ILdExpenseStat, IVoyageExportStat } from "../models/stats";
import { VoyageStatus } from "../models/booking";

type StatsExpensePerShipResponse = { data: StatsExpensePerShip[] };
type StatsExpensePerDockResponse = { data: StatsExpensePerDock[] };
type StatsExpensePerShipAndDockResponse = { data: StatsExpensePerShipAndDock[] };

export const getStatsExpensePerShip = async (
    filter: CsvStatisticsFilters,
): Promise<AxiosResponse<StatsExpensePerShipResponse>> => {
    return await axios.post(`/dispatcher/stats/expense/ship`, filter);
};

export const getStatsExpensePerDock = async (
    filter: CsvStatisticsFilters,
): Promise<AxiosResponse<StatsExpensePerDockResponse>> => {
    return await axios.post(`/dispatcher/stats/expense/dock`, filter);
};

export const getStatsExpensePerShipAndDock = async (
    filter: CsvStatisticsFilters,
): Promise<AxiosResponse<StatsExpensePerShipAndDockResponse>> => {
    return await axios.post(`/dispatcher/stats/expense/ship-and-dock`, filter);
};

export const getStatsBerthingsPerDock = async (
    filters: StatisticsFilters,
): Promise<AxiosResponse<StatsBerthingsPerDock[]>> => {
    return await axios.post(`/dispatcher/stats/berthing/dock`, filters);
};

export const getDashboardStats = async (
    filters: StatisticsFilters,
): Promise<AxiosResponse<DashboardStats>> => {
    return await axios.post(`/dispatcher/stats/dashboard`, filters);
};

export const getStatsBookingPerStatus = async (
    filters: StatisticsFilters,
): Promise<AxiosResponse<StatsBookingPerStatus[]>> => {
    return await axios.post(`/dispatcher/stats/booking/status`, filters);
};

export const getVoyageExportStats = async (
    from: number,
    to: number,
    shipId?: string,
    statuses?: VoyageStatus[],
): Promise<IVoyageExportStat[]> => {
    const { data } = await axios.post("/docks/stats/voyageExport", {
        from,
        to,
        shipId,
        statuses,
    });
    return Array.isArray(data) ? data : (data?.data ?? []);
};

export const getLDShipAndDockExpenseStats = async (
    from: number,
    to: number,
): Promise<ILdExpenseStat[]> => {
    const { data } = await axios.post("/docks/stats/expense/ship-and-dock", { from, to });
    return Array.isArray(data) ? data : (data?.data ?? []);
};

export const getLDExpensePerShipStats = async (from: number, to: number): Promise<any[]> => {
    const { data } = await axios.post("/docks/stats/expense/ship", { from, to });
    return Array.isArray(data) ? data : (data?.data ?? []);
};
